/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from 'react';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
} from '@mui/material';
import { FDProvider, FDContext } from 'contexts/Map/fdStore';

import { makeStyles } from '@mui/styles';
import { Link, useLocation, useHistory } from 'react-router-dom';

import { BackArrowIcon } from 'icons';

import {
  BBoxIcon,
  GlobeIcon,
  InfoIcon,
  PointerIcon,
  DocumentationIcon,
  CoverageIcon,
} from '../../icons';

import LeftDrawer from '../../components/FDMapView/LeftDrawer';
import RightDrawer from '../../components/FDMapView/RightDrawer';
import {
  setLocation,
  setDataLayerFD,
  setAPIFD,
} from '../../contexts/Map/action';
import { getDataLayerConfig } from '../../api/fieldDelineation/mapApi';
import NavBar from '../../components/NavBar';

import Map, {
  DrawProvider,
  MapProvider,
} from '../../components/FDMapView/index';

const useStyles = makeStyles((theme) => ({
  dashboardRoot: {
    display: 'flex',
    paddingTop: '64px',
    minHeight: '100vh',
  },
  dropdownContainer: {
    position: 'absolute',
    // marginTop: 6,
    top: 10,
    left: 16,
    zIndex: 1,
    display: 'flex',
    '& >div': {
      marginRight: 8,
      marginBottom: 4,
    },
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  select: {
    backgroundColor: '#fff',
    minWidth: 120,
    textAlign: 'left',
    fontWeight: 600,

    '&:focus': {
      backgroundColor: '#fff',
      borderRadius: 8,
      border: 'none',
    },
  },
  formControl: {
    '&:hover': {
      border: '1px solid #949EA7',
    },
  },
  outlined: {},
  selectIcon: {
    color: theme.palette.primary.main,
  },
  toggleButtonGroup: {
    backgroundColor: '#fff',
    border: 'none',
    display: 'inline-block',
    borderRadius: 8,
    padding: 4,
    marginLeft: 16,
  },
  toggleButton: {
    fontWeight: 600,
    textTransform: 'capitalize',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      boxShadow: 'none',
    },
  },
  toggleButtonActive: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  aboutApiQueries: {
    position: 'absolute',
    bottom: 16,
    left: 16,
    zIndex: 4,
    lineHeight: '16px',
  },
  aboutApiQueriesButton: {
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff',
    },
    textTransform: 'capitalize',
    color: '#01B075',
    fontWeight: 600,
  },
  infoIcon: {
    fill: 'none',
    stroke: '#01B075',
    marginRight: 4,
  },
  apiSelection: {
    position: 'absolute',
    left: 16,
    top: '40vh',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: '0 6px',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      top: '120px',
    },
  },
  backToProjectsContainer: {
    position: 'absolute',
    top: '10px',
    left: '16px',
    // transform: 'translateX(-50%)',
    backgroundColor: '#fff',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '15px 15px',
    borderRadius: '8px',
    border: '1px solid black',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '@media (max-width: 600px)': {
      width: '90%',
      left: '5%',
      transform: 'none',
    },
  },
  apiButton: {
    fontSize: 10,
    lineHeight: 1.2,
    fontWeight: 500,
    padding: '9px 0',
    '& svg path': {
      stroke: '#1D2023',
    },
    cursor: 'pointer',
  },
  apiButtonActive: {
    color: '#01B075',
    '& svg path': {
      stroke: '#01B075',
    },
    fontSize: 10,
  },
  mainDashboard: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  mapAndDrawer: {
    flex: 1,
    display: 'flex',
    height: 'calc(100vh - 64px)',
  },
  rightPanel: {
    position: 'relative',
    height: 'calc(100vh - 64px)', // Full height minus header
    padding: '0 64px 0 0', // Padding on the right
    backgroundColor: '#fff',
    flex: 1,
  },
  mapContainer: {
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
  },
  iconRoot: {
    fill: 'none !important',
    stroke: '#1d2023',
  },
  ml2: {
    marginLeft: '2px',
  },
  inputLabelForm: {
    color: '#1d2023',
    fontSize: '1rem',
    fontWeight: 400,
    marginBottom: '8px',
    marginTop: '4px',

    // backgroundColor: '#fff',
    padding: '0 4px',
    borderRadius: '4px',
    transform: 'translate(14px, -6px) scale(0.75)',
    '&.Mui-focused': {
      color: '#01B075',
    },
    '&.Mui-error': {
      color: '#f44336',
    },
  },
}));

const FieldDelineationMapView = () => {
  const classes = useStyles();
  const [region, setRegion] = useState('norway');

  const {
    state: { dataLayerFD },
    dispatch,
  } = useContext(FDContext);

  const initialZoom = window.location.hash
    ? window.location.hash.substring(1).split('/')[0]
    : 13;
  const [zoom, setZoom] = useState(initialZoom);
  const [toggleLeftDrawer, setToggleLeftDrawer] = useState(false);
  const [isRightDrawerOpen, setIsRightDrawerOpen] = useState(true);
  const [dataLayerConfig, setDataLayerConfig] = useState({});

  const toggleRightDrawer = () => {
    setIsRightDrawerOpen(!isRightDrawerOpen);
  };

  useEffect(() => {
    getDataLayerConfig().then((config) => {
      setDataLayerConfig(config);
      setRegion(Object.keys(config[dataLayerFD.type].locations)[0]);
    });
  }, []);

  return (
    <div>
      <NavBar Title="FD" />
      <MapProvider>
        <DrawProvider>
          <div className={classes.dashboardRoot}>
            <div className={classes.rightPanel}>
              <Link
                className={classes.backToProjectsContainer}
                to="/delineated-fields/subscriptions"
              >
                <BackArrowIcon className={classes.iconRoot} />
                <div>Back to Orders</div>
              </Link>
              <div className={classes.mainDashboard}>
                <div className={classes.mapAndDrawer}>
                  <div className={classes.dropdownContainer}>
                    <FormControl>
                      {/* <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                        className={classes.inputLabelForm}
                      >
                        Location
                      </InputLabel> */}
                      <Select
                        variant="outlined"
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        classes={{
                          root: classes.select,
                          icon: classes.selectIcon,
                          outlined: classes.outlined,
                        }}
                        style={{ display: 'none' }}
                        value={region}
                        onChange={(event) => {
                          setRegion(event.target.value);
                          dispatch({
                            type: setLocation,
                            payload: {
                              location:
                                dataLayerConfig[dataLayerFD.type].locations[
                                  event.target.value
                                ],
                            },
                          });
                        }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                          getContentAnchorEl: null,
                          PaperProps: {
                            style: {
                              marginTop: '55px',
                            },
                          },
                        }}
                      >
                        {dataLayerFD &&
                          Object.keys(
                            dataLayerConfig?.[dataLayerFD.type]?.locations ?? {}
                          ).map((key) => (
                            <MenuItem key={key} value={key}>
                              {
                                dataLayerConfig[dataLayerFD.type].locations[key]
                                  .name
                              }
                              <img
                                src={`https://flagcdn.com/20x15/${
                                  dataLayerConfig[dataLayerFD.type].locations[
                                    key
                                  ].country_code
                                }.png`}
                                width="18"
                                height="auto"
                                className={classes.ml2}
                                alt={
                                  dataLayerConfig[dataLayerFD.type].locations[
                                    key
                                  ].country_code
                                }
                              />
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>

                    <FormControl>
                      {/* <InputLabel
                        shrink
                        className={classes.inputLabelForm}
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Data Layer
                      </InputLabel> */}
                      <Select
                        variant="outlined"
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        classes={{
                          root: classes.select,
                          icon: classes.selectIcon,
                          outlined: classes.outlined,
                        }}
                        style={{ display: 'none' }}
                        value={dataLayerFD.type}
                        onChange={(event) => {
                          const listOfLocationsForTheDatalayer = Object.keys(
                            dataLayerConfig[event.target.value].locations
                          );
                          const newLocation = listOfLocationsForTheDatalayer[0];

                          setRegion(newLocation);

                          const newLocationObj = {
                            location:
                              dataLayerConfig[event.target.value].locations[
                                newLocation
                              ],
                          };

                          const dataLayerPayload = {
                            type: event.target.value,
                          };

                          switch (event.target.value) {
                            case 'delineatedFields':
                              dataLayerPayload.api = 'point';
                              dataLayerPayload.drawMode = 'draw_single_point';
                              break;

                            // Commenting out other cases
                            // case 'deepResImages':
                            //   dataLayerPayload.api = dataLayerConfig[
                            //     event.target.value
                            //   ].tileXYZ
                            //     ? 'xyz'
                            //     : 'coverage';
                            //   dataLayerPayload.drawMode = undefined;
                            //   break;

                            default:
                              dataLayerPayload.api = 'lowResBBOX';
                              dataLayerPayload.drawMode = 'draw_rectangle';
                              break;
                          }

                          const payload =
                            event.target.value !== 'timeSeries'
                              ? {
                                  dataLayerFD: dataLayerPayload,
                                  ...newLocationObj,
                                }
                              : { dataLayerFD: dataLayerPayload };
                          dispatch({
                            type: setDataLayerFD,
                            payload,
                          });
                        }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        {Object.keys(dataLayerConfig).map(
                          (api) =>
                            api === 'delineatedFields' ? (
                              <MenuItem key={api} value={api}>
                                {dataLayerConfig[api].name}
                              </MenuItem>
                            ) : null // Commenting out other options
                        )}
                      </Select>
                    </FormControl>
                  </div>

                  <LeftDrawer
                    open={toggleLeftDrawer}
                    onClose={() => setToggleLeftDrawer(false)}
                  />

                  <Map
                    layer={dataLayerFD.type}
                    zoom={zoom}
                    setZoom={setZoom}
                    // toggleRightDrawer={toggleRightDrawer}
                    isRightDrawerOpen={isRightDrawerOpen}
                    dataLayerConfig={dataLayerConfig}
                  />
                  {dataLayerFD.type === 'delineatedFields' ? (
                    <div className={classes.apiSelection}>
                      <div
                        className={[
                          classes.apiButton,
                          dataLayerFD.api === 'lowResBBOX' ||
                          dataLayerFD.api === 'lowResTile'
                            ? classes.apiButtonActive
                            : '',
                        ].join(' ')}
                        role="button"
                        tabIndex="0"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'lowResBBOX',
                              drawMode: 'draw_rectangle',
                            },
                          })
                        }
                      >
                        <GlobeIcon />
                        <div>Field ID</div>
                      </div>
                      <div
                        className={
                          dataLayerFD.api === 'point'
                            ? [classes.apiButtonActive, classes.apiButton].join(
                                ' '
                              )
                            : [classes.apiButton]
                        }
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'point',
                              drawMode: 'draw_single_point',
                            },
                          })
                        }
                      >
                        <PointerIcon classes={{ root: classes.iconRoot }} />
                        <div>Point</div>
                      </div>
                      <div
                        className={
                          dataLayerFD.api === 'bbox'
                            ? [classes.apiButtonActive, classes.apiButton].join(
                                ' '
                              )
                            : [classes.apiButton]
                        }
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'bbox',
                              drawMode: 'draw_rectangle',
                            },
                          })
                        }
                      >
                        <BBoxIcon classes={{ root: classes.iconRoot }} />
                        <div>Bbox</div>
                      </div>
                      <div
                        className={
                          dataLayerFD.api === 'coverage'
                            ? [classes.apiButtonActive, classes.apiButton].join(
                                ' '
                              )
                            : [classes.apiButton]
                        }
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'coverage',
                              drawMode: '',
                            },
                          })
                        }
                      >
                        <CoverageIcon classes={{ root: classes.iconRoot }} />
                        <div>Coverage</div>
                      </div>
                    </div>
                  ) : dataLayerFD.type === 'deepResImages' ? (
                    <div className={classes.apiSelection}>
                      {dataLayerConfig[dataLayerFD.type].tileXYZ && (
                        <>
                          <div
                            className={[
                              classes.apiButton,
                              dataLayerFD.api === 'xyz'
                                ? classes.apiButtonActive
                                : '',
                            ].join(' ')}
                            role="button"
                            onClick={() =>
                              dispatch({
                                type: setAPIFD,
                                payload: {
                                  api: 'xyz',
                                  // drawMode: "draw_rectangle",
                                },
                              })
                            }
                          >
                            <GlobeIcon />
                            <div>Tile URL</div>
                          </div>
                          <div
                            className={[
                              classes.apiButton,
                              dataLayerFD.api === 'bbox'
                                ? classes.apiButtonActive
                                : '',
                            ].join(' ')}
                            role="button"
                            onClick={() =>
                              dispatch({
                                type: setAPIFD,
                                payload: {
                                  api: 'bbox',
                                  drawMode: 'draw_rectangle',
                                },
                              })
                            }
                          >
                            <BBoxIcon classes={{ root: classes.iconRoot }} />
                            <div>BBOX</div>
                          </div>
                        </>
                      )}

                      <div
                        className={
                          dataLayerFD.api === 'coverage'
                            ? [classes.apiButtonActive, classes.apiButton].join(
                                ' '
                              )
                            : [classes.apiButton]
                        }
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'coverage',
                              drawMode: '',
                            },
                          })
                        }
                      >
                        <CoverageIcon classes={{ root: classes.iconRoot }} />
                        <div>Coverage</div>
                      </div>
                    </div>
                  ) : (
                    <div className={classes.apiSelection}>
                      <div
                        className={[
                          classes.apiButton,
                          dataLayerFD.api === 'lowResBBOX' ||
                          dataLayerFD.api === 'lowResTile'
                            ? classes.apiButtonActive
                            : '',
                        ].join(' ')}
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'lowResBBOX',
                              drawMode: 'draw_rectangle',
                            },
                          })
                        }
                      >
                        <GlobeIcon />
                        <div>Field ID</div>
                      </div>
                      <div
                        className={
                          dataLayerFD.api === 'coverage'
                            ? [classes.apiButtonActive, classes.apiButton].join(
                                ' '
                              )
                            : [classes.apiButton]
                        }
                        role="button"
                        onClick={() =>
                          dispatch({
                            type: setAPIFD,
                            payload: {
                              api: 'coverage',
                              drawMode: '',
                            },
                          })
                        }
                      >
                        <CoverageIcon classes={{ root: classes.iconRoot }} />
                        <div>Coverage</div>
                      </div>
                    </div>
                  )}

                  {/* <div className={classes.aboutApiQueries}>
                    <Button
                      className={classes.aboutApiQueriesButton}
                      onClick={() => setToggleLeftDrawer(true)}
                      variant="contained"
                    >
                      <InfoIcon classes={{ root: classes.infoIcon }} /> about
                      API queries
                    </Button>
                    <br />
                    <br />
                    <Button
                      className={classes.aboutApiQueriesButton}
                      variant="contained"
                      target="_blank"
                      href="https://digifarming.readme.io/reference"
                      underline="none"
                      rel="noopener noreferrer"
                    >
                      <DocumentationIcon classes={{ root: classes.infoIcon }} />{' '}
                      Full Documentation
                    </Button>
                  </div> */}
                  {isRightDrawerOpen && (
                    <RightDrawer
                      open={isRightDrawerOpen}
                      onClose={() => {
                        setIsRightDrawerOpen(false);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </DrawProvider>
      </MapProvider>
    </div>
  );
};

const FieldDelineationMapViewWrapper = (props) => (
  <FDProvider>
    <FieldDelineationMapView {...props} />
  </FDProvider>
);

export default FieldDelineationMapViewWrapper;
